import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import AccountCircle from '@material-ui/icons/AccountCircle';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { Link } from 'react-router-dom'
import { Delete, ExitToApp, Home, Help } from '@material-ui/icons';

import { Chip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    appBar: {
        zIndex: theme.zIndex.drawer + 9,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
}));

export default function HeaderBar({ user, hasData, isAdmin, onAdminClick, onLogout, onDelete, onHelp }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleLogout = () => {
        setAnchorEl(null);
        onLogout();
    }

    const handleDelete = () => {
        onDelete();
        setAnchorEl(null);
    }

    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
                <Typography variant="h6">
                    MazingDay
                </Typography>
                {isAdmin &&
                    (<IconButton aria-label="delete" component={Link} to="/" onClick={onAdminClick}>
                        <Home />
                    </IconButton>)
                }
                <div style={{ flexGrow: '1' }}></div>
                {
                    isAdmin ?
                        (
                            <Chip
                                style={{ color: "#fff", borderColor: "#fff" }}
                                avatar={<AccountCircle style={{ color: "#fff" }} />}
                                label="Admin"
                                onClick={handleMenu}
                                variant="outlined"
                            />
                        ) : (
                            <IconButton
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                            >
                                <AccountCircle />
                            </IconButton>
                        )
                }
                <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    keepMounted
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                >
                    <MenuItem style={{ padding: '16px 24px' }} disabled>
                        <AccountCircle style={{ marginRight: 8 }} />
                        {user.username}
                    </MenuItem>

                    {hasData && <MenuItem onClick={handleDelete} style={{ color: 'red', padding: '16px 24px' }}>
                        <Delete style={{ marginRight: 8 }} />
                        Delete Provider info
                    </MenuItem>}

                    <MenuItem style={{ padding: '16px 24px' }} component={Link} to="/help" onClick={onAdminClick}>
                        <Help style={{ marginRight: 8 }} />
                        Help
                    </MenuItem>

                    <MenuItem onClick={handleLogout} style={{ padding: '16px 24px' }}>
                        <ExitToApp style={{ marginRight: 8 }} />
                        Logout
                    </MenuItem>
                </Menu>
                <Chip
                    style={{ color: "#fff", borderColor: "#fff", marginLeft: 15 }}
                    label="v 0.1"
                    variant="outlined"
                />
            </Toolbar>
        </AppBar>
    );
}